import { useNavigate } from '@tanstack/react-router';

import { useWebT } from '../hooks';
import { useCompanion } from '../session/WebSessionProvider';

/** The pink strip of MW-08: only on a phone, only in companion (§5.4). */
export function PartyBanner() {
  const t = useWebT();
  const companion = useCompanion();
  const navigate = useNavigate();
  if (!companion.active || companion.ended) return null;
  return (
    <div
      data-testid="party-banner"
      className="flex h-11 shrink-0 items-center justify-between gap-3 bg-pink px-5 pt-[var(--akm-safe-top)] text-[13px] text-white lg:hidden"
    >
      <span className="min-w-0 truncate font-semibold">
        {t('web:party.companion.banner', { code: companion.joinCode ?? '' })}
      </span>
      <button
        type="button"
        className="shrink-0 font-bold"
        onClick={() => {
          void companion.leave().then(() => navigate({ to: '/' }));
        }}
      >
        {t('web:party.companion.leave')}
      </button>
    </div>
  );
}
